export const domain = process.env.REACT_APP_DOMAIN || '';
export const clientId =
  process.env.REACT_APP_CLIENT_ID || '';
export const redirectUrl =
  process.env.REACT_APP_REDIRECT_URL || '';
export const scope =
  process.env.REACT_APP_USER_SCOPE ||
  '';
export const barbersLimitedRegistrationApiUrl =
  process.env.REACT_APP_BARBERS_REGISTRATION_API_URL || '';
export const barbersLimitedReservationApiUrl =
  process.env.REACT_APP_BARBERS_RESERVATION_API_URL || '';
export const adminPassword =
  process.env.REACT_APP_ADMIN_PASSWORD || '';
export const adminUsername =
  process.env.REACT_APP_ADMIN_USERNAME || '';
export const googleMapsApiKey =
  process.env.REACT_APP_GOOGLE_MAPS_API_KEY || '';
export const stripePublishableKey =
  process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || '';
export const barberStandardProductId = process.env.REACT_APP_BARBER_STANDARD_PRODUCT_ID || '';
export const barberStandardPriceId = process.env.REACT_APP_BARBER_STANDARD_PRICE_ID || '';
export const shopOwnerStandardProductId = process.env.REACT_APP_SHOP_OWNER_STANDARD_PRODUCT_ID || '';
export const shopOwnerStandardPriceId = process.env.REACT_APP_SHOP_OWNER_STANDARD_PRICE_ID || '';
export const shopOwnerCrewProductId = process.env.REACT_APP_SHOP_OWNER_CREW_PRODUCT_ID || '';
export const shopOwnerCrewPriceId = process.env.REACT_APP_SHOP_OWNER_CREW_PRICE_ID || '';
export const shopOwnerSquadProductId = process.env.REACT_APP_SHOP_OWNER_SQUAD_PRODUCT_ID || '';
export const shopOwnerSquadPriceId = process.env.REACT_APP_SHOP_OWNER_SQUAD_PRICE_ID || '';
export const barberTestAccountIdList: bigint[] = (process.env.REACT_APP_BARBER_TEST_ACCOUNT_ID_LIST || '').split(',').map(BigInt);
export const shopTestAccountIdList: bigint[] = (process.env.REACT_APP_SHOP_TEST_ACCOUNT_ID_LIST || '').split(',').map(BigInt);
